import View from '../../View';

/**
 * ArticleBlock
 */
class ArticleBlock extends View {
    constructor (node) {
        super(node);

        this.openButton = this.node.querySelector('.js-show-abstract-button');
        this.closeButton = this.node.querySelector('.js-hide-abstract-button');

        this.openButton.addEventListener('click', this.openClickHandler);
        this.closeButton.addEventListener('click', this.closeClickHandler);
    }

    /**
     * Show the abstract when clicked
     * @param e
     */
    openClickHandler = (e) => {
        this.node.classList.add('mod-show-abstract');
    };

    /**
     * Hide the abstract when clicked
     * @param e
     */
    closeClickHandler = (e) => {
        this.node.classList.remove('mod-show-abstract');
    };
}

export default ArticleBlock;



// WEBPACK FOOTER //
// frontend/js/components/blocks/ArticleBlock.js